import { IAbUseExperiment } from '../../types/abUseExperiments';
import { CPD_LABEL_EXPERIMENT } from 'shared/constants/experiments';

export function isCpdLabelExperimentActive(experiments: IAbUseExperiment[] = []) {
  const experiment = experiments.find(exp => exp.experimentName === CPD_LABEL_EXPERIMENT);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === 'B';
}
